import apiClient from './api/client';
import ENDPOINTS from './api/endpoints';

const SHIFT_REPORT_PERIOD_VALUES = {
  today: 'TODAY',
  yesterday: 'YESTERDAY',
  last7Days: '7D',
  last30Days: '1M',
};

function buildShiftReportParams(period, startDate, endDate) {
  if (period === 'custom' && startDate && endDate) {
    return { startDate, endDate };
  }
  return { period: SHIFT_REPORT_PERIOD_VALUES[period] || 'TODAY' };
}

export const dayCloseService = {
  getSummary: async (businessDate) => {
    try {
      const params = businessDate ? { businessDate } : {};
      const response = await apiClient.get(ENDPOINTS.DAY_CLOSE.GET_SUMMARY, { params });
      return response;
    } catch (error) {
      console.error('Failed to fetch day close summary:', error);
      throw error;
    }
  },

  executeDayClose: async (businessDate, notes, actualCash) => {
    try {
      const response = await apiClient.post(ENDPOINTS.DAY_CLOSE.EXECUTE, {
        businessDate,
        notes: notes || null,
        actualCash: actualCash != null ? actualCash : null,
      });
      return response;
    } catch (error) {
      console.error('Failed to execute day close:', error);
      throw error;
    }
  },

  reopenDay: async (businessDate, reason) => {
    try {
      const response = await apiClient.post(ENDPOINTS.DAY_CLOSE.REOPEN, {
        businessDate,
        notes: reason,
      });
      return response;
    } catch (error) {
      console.error('Failed to reopen day:', error);
      throw error;
    }
  },

  getHistory: async (params = {}) => {
    try {
      const response = await apiClient.get(ENDPOINTS.DAY_CLOSE.HISTORY, { params });
      return response;
    } catch (error) {
      console.error('Failed to fetch day close history:', error);
      throw error;
    }
  },

  downloadPdf: async (businessDate) => {
    try {
      const response = await apiClient.get(ENDPOINTS.DAY_CLOSE.DOWNLOAD_PDF, {
        params: { businessDate },
        responseType: 'blob',
      });
      return response;
    } catch (error) {
      console.error('Failed to download day close PDF:', error);
      throw error;
    }
  },

  // ── Shift Report (financial snapshot / payment collections / orders) ──
  // period: 'today' | 'yesterday' | 'last7Days' | 'last30Days' | 'custom'
  // startDate/endDate ('YYYY-MM-DD') only used when period === 'custom'

  getShiftReportFinancialSnapshot: async (period, startDate, endDate) => {
    try {
      const response = await apiClient.get(ENDPOINTS.DASHBOARD.GET_FINANCIAL_SNAPSHOT, {
        params: buildShiftReportParams(period, startDate, endDate),
      });
      return response;
    } catch (error) {
      console.error('Failed to fetch shift report financial snapshot:', error);
      throw error;
    }
  },

  getShiftReportPaymentCollections: async (period, startDate, endDate) => {
    try {
      const response = await apiClient.get(ENDPOINTS.DASHBOARD.GET_PAYMENT_MODEWISE, {
        params: buildShiftReportParams(period, startDate, endDate),
      });
      return response;
    } catch (error) {
      console.error('Failed to fetch shift report payment collections:', error);
      throw error;
    }
  },

  getShiftReportOrdersSummary: async (period, startDate, endDate) => {
    try {
      const response = await apiClient.get(ENDPOINTS.DASHBOARD.GET_ORDERS_SUMMARY, {
        params: buildShiftReportParams(period, startDate, endDate),
      });
      return response;
    } catch (error) {
      console.error('Failed to fetch shift report orders summary:', error);
      throw error;
    }
  },
};

export default dayCloseService;